module.exports = __webpack_public_path__ + "static/img/K2.ac78e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/K2.jpg
// module id = FsSz
// module chunks = 1